export const AppLinks = {
	home: '/',
	catalog: '/catalog',
	basket: '/bakset',
	admin: '/admin'
} as const